<template>
    <ul class="template-list">
        <li
            v-for="template in templates"
            :key="template.type"
            class="template-item"
        >
            <button
                class="template-button"
                :class="{ selected: selectedTemplate?.type === template.type }"
                @click="selectTemplate(template)"
            >
                <img :src="template.image" alt="" class="template-image" />
            </button>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'SelectTemplate',
        props: {
            templates: {
                type: Array,
                required: true,
            },
            selected: {
                type: Number,
                default: 1,
            },
        },
        emits: ['template-selected'],
        data() {
            return {
                selectedTemplate: null,
            };
        },
        mounted() {
            this.updateSelectedTemplate();
        },
        watch: {
            selected() {
                this.updateSelectedTemplate();
            },
            templates() {
                this.updateSelectedTemplate();
            },
        },
        methods: {
            selectTemplate(template) {
                this.selectedTemplate = template;
                this.$emit('template-selected', template);
            },
            updateSelectedTemplate() {
                if (this.templates && this.templates.length > 0) {
                    const found = this.templates.find(
                        (t) => t.type === this.selected
                    );
                    this.selectedTemplate = found || this.templates[0];
                } else {
                    this.selectedTemplate = null;
                }
            },
        },
    };
</script>

<style scoped>
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .template-list {
        padding: 8px;
        max-height: 76svh;
        overflow-y: scroll;
    }

    .template-item:not(:last-child) {
        margin-bottom: 12px;
    }

    .template-button {
        width: 100%;
        cursor: pointer;
        padding: 2px;
        border: 2px solid transparent;
        border-radius: 10px;
        transition: transform 0.3s ease;
    }

    .template-button.selected {
        border-color: #07a5ad;
    }

    .template-image {
        width: 100%;
        height: auto;
        border-radius: 8px;
    }

    @media screen and (min-width: 768px) {
        .template-list {
            padding: 12px 16px;
        }
    }
</style>
